"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserInfo = void 0;

var _userInfo = _interopRequireDefault(require("hub-http/userInfo"));

var getUserInfo = _userInfo.default;
exports.getUserInfo = getUserInfo;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/api/getUserInfo.js
// module id = 314
// module chunks = 5 6